import { useEffect } from 'react'
import { RootState, useAppDispatch, useAppSelector } from '../../redux/store'
import { fetchAssignedTaskDetails, FetchAssignedTaskDetailsPayload } from '../../redux/task/actions'

const useFetchAssignedTaskDetails = (
  payload: FetchAssignedTaskDetailsPayload,
  refreshTrigger?: number,
) => {
  const dispatch = useAppDispatch()
  const { errorAssignTask, assignedTask, loadingAssignTask } = useAppSelector(
    (state: RootState) => state.task,
  )

  useEffect(() => {
    const fetchData = async () => {
      if (payload.teamMemberEmail && payload.teamMemberWorkdayId) {
        await dispatch(fetchAssignedTaskDetails(payload))
      }
    }

    fetchData()
  }, [payload, refreshTrigger])

  return { tasks: assignedTask, loadingAssignTask, error: errorAssignTask }
}

export default useFetchAssignedTaskDetails
